"use strict";
/// <reference path="Upload.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.Upload = void 0;
require("@progress/kendo-ui");
const $ = require("jquery");
const Base64_1 = require("../../javascript/Base64");
const Utilities_1 = require("../../javascript/Utilities");
require("./Upload.less");
class Upload {
    static init($elem, options) {
        if (!options)
            options = {};
        return $elem.each(function () {
            const $this = $(this);
            let childInput = $this.children("input");
            let upload = childInput.data('kendoUpload');
            if (!upload) { // the plugin hasn't been initialized yet
                let mergedData = $.extend({
                    uploadUrl: Utilities_1.synUtil.getWSUrl("ContentUpload"),
                    removeUrl: Utilities_1.synUtil.getWSUrl("DeleteContentUpload"),
                    allowMultiple: true,
                    showFileList: true,
                    initialFiles: [],
                    cancelledItems: {},
                    mapFileToGUID: {},
                    localization: {},
                    checkForDocument: options.document || undefined,
                    checkForCategory: options.category || undefined,
                    strings: {
                        noMoreThenOneFile: "No more than one file allowed.",
                        fileAlreadyAdded: "File {0} already added."
                    },
                }, options);
                mergedData.localization = $.extend({
                    cancel: Utilities_1.synUtil.Strings.getValue("menucancel", "Cancel"),
                    dropFilesHere: Utilities_1.synUtil.Strings.getValue("dropfileshere", "Drop file(s) here"),
                    remove: Utilities_1.synUtil.Strings.getValue("webtoolkituploadremove", "Remove"),
                    retry: Utilities_1.synUtil.Strings.getValue("webtoolkituploadretry", "Retry?"),
                    select: mergedData.allowMultiple ?
                        Utilities_1.synUtil.Strings.getValue("webtoolkituploadchoosefiles", "Choose files")
                        : Utilities_1.synUtil.Strings.getValue("webtoolkituploadchoosefile", "Choose file"),
                    headerStatusUploaded: Utilities_1.synUtil.Strings.getValue("webtoolkituploadsuccess", "Upload successful"),
                    headerStatusUploading: Utilities_1.synUtil.Strings.getValue("webtoolkituploading", "Uploading..."),
                    statusFailed: Utilities_1.synUtil.Strings.getValue("webtoolkituploadfailed", "Upload failed!"),
                    statusUploaded: Utilities_1.synUtil.Strings.getValue("webtoolkituploadsuccess", "Upload successful"),
                    statusUploading: Utilities_1.synUtil.Strings.getValue("webtoolkituploading", "Uploading..."),
                    uploadSelectedFiles: Utilities_1.synUtil.Strings.getValue("webtoolkituploaduploadselectedfiles", "Upload files..."),
                }, mergedData.localization);
                mergedData.strings = {
                    noMoreThenOneFile: Utilities_1.synUtil.Strings.getValue("webtoolkituploadnomorethanonefile", "Only 1 file may be selected!"),
                    fileAlreadyAdded: Utilities_1.synUtil.Strings.getValue("webtoolkituploadfilealreadyadded", "File \"{0}\" has already been added!")
                };
                if (!mergedData.sessionGUID)
                    mergedData.sessionGUID = Utilities_1.synUtil.getGUID(true);
                if (!$this.is("div.synUploadDiv") || !childInput.length)
                    alert("wrong html element for synUpload! Target element must a <div class='synUploadDiv' /> containing an <input /> element!");
                if (mergedData.initialFiles.length > 0) {
                    $.each(mergedData.initialFiles, function (index, item) {
                        mergedData.mapFileToGUID[item.name + "_" + mergedData.sessionGUID + "_" + item.fileGuid] = item.fileGuid;
                    });
                }
                let uploadErrorFunc = function (e) {
                    const synData = $this.data("synData");
                    let addlText = "";
                    if (e.XMLHttpRequest) {
                        let err = JSON.parse(e.XMLHttpRequest.responseText);
                        while (err && err.ErrorDisplayMessage) {
                            addlText += "\r\n" + err.ErrorDisplayMessage;
                            err = err.InnerError;
                        }
                    }
                    $this.find(".k-upload-status-total").remove();
                    for (let i = 0; i < e.files.length; i++) {
                        let fileKey = Utilities_1.synUtil.getFileName(e.files[i].name) + "_" + synData.sessionGUID;
                        if (e.files[i].fileGuid)
                            fileKey += "_" + e.files[i].fileGuid;
                        synData.cancelledItems[fileKey] = true;
                    }
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("webtoolkituploadfailed", "Upload failed!") + addlText);
                    $this.trigger("uploadError", [e.files]);
                };
                mergedData.upload = childInput.kendoUpload({
                    async: {
                        batch: false,
                        saveUrl: mergedData.uploadUrl + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                        removeUrl: mergedData.removeUrl + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken,
                        removeVerb: "DELETE",
                        autoUpload: true
                    },
                    localization: mergedData.localization,
                    files: mergedData.initialFiles,
                    multiple: mergedData.allowMultiple,
                    showFileList: mergedData.showFileList,
                    cancel(e) {
                        const synData = $this.data("synData");
                        if (e.files)
                            for (let i = 0; i < e.files.length; i++) {
                                let fileKey = Utilities_1.synUtil.getFileName(e.files[i].name) + "_" + synData.sessionGUID;
                                if (e.files[i].fileGuid)
                                    fileKey += "_" + e.files[i].fileGuid;
                                synData.cancelledItems[fileKey] = true;
                            }
                        $this.trigger("uploadCancelled", [e.files]);
                    },
                    complete(e) {
                        $this.trigger("uploadComplete");
                    },
                    error: uploadErrorFunc,
                    progress(e) {
                        $this.trigger("uploadProgress", [e.files, e.percentComplete]);
                    },
                    remove(e) {
                        const synData = $this.data("synData");
                        let deleteGUIDs = [];
                        if (e.files)
                            for (let i = 0; i < e.files.length; i++) {
                                let fileKey = Utilities_1.synUtil.getFileName(e.files[i].name) + "_" + synData.sessionGUID;
                                if (e.files[i].fileGuid)
                                    fileKey += "_" + e.files[i].fileGuid;
                                if (fileKey in synData.mapFileToGUID) {
                                    let fileGuid = synData.mapFileToGUID[fileKey];
                                    if (fileGuid) {
                                        deleteGUIDs.push(fileGuid);
                                        delete synData.mapFileToGUID[fileKey];
                                    }
                                }
                            }
                        e.data = {
                            deleteGUIDs: deleteGUIDs.join(";"),
                            sessionGUID: synData.sessionGUID
                        };
                        $this.trigger("fileRemoved", [e.data]);
                    },
                    select(e) {
                        const synData = $this.data("synData");
                        let cancelEvent = false;
                        if (!synData.allowMultiple) {
                            let currentfiles = 0;
                            for (let key in synData.mapFileToGUID)
                                if (synData.mapFileToGUID[key])
                                    currentfiles++;
                            if (currentfiles !== 0 || e.files > 1) {
                                cancelEvent = true;
                                $.errorDialog({
                                    ErrorDisplayMessage: mergedData.strings.noMoreThenOneFile
                                });
                            }
                        }
                        if (!cancelEvent) {
                            $.each(e.files, function (index, value) {
                                let fileName = Utilities_1.synUtil.getFileName(value.name);
                                let fileKey = fileName + "_" + synData.sessionGUID;
                                if (value.fileGuid)
                                    fileKey += "_" + value.fileGuid;
                                let newItems = {};
                                for (let prop in synData.cancelledItems)
                                    if (synData.cancelledItems.hasOwnProperty(prop))
                                        if (prop !== fileKey)
                                            newItems[prop] = true;
                                synData.cancelledItems = newItems;
                            });
                        }
                        if (cancelEvent)
                            e.preventDefault();
                        else {
                            $.each(e.files, function (index, value) {
                                let fileKey = Utilities_1.synUtil.getFileName(value.name) + "_" + synData.sessionGUID;
                                if (value.fileGuid)
                                    fileKey += "_" + value.fileGuid;
                                synData.mapFileToGUID[fileKey] = "";
                            });
                            $this.trigger("fileSelected", [e.files]);
                        }
                    },
                    success(e) {
                        if (e.response && (e.response.ErrorMessage || e.response.ErrorDisplayMessage))
                            uploadErrorFunc(e);
                        else {
                            const synData = $this.data("synData");
                            if (e.operation === "remove") {
                                $.each(e.files, function (index, value) {
                                    let fileKey = Utilities_1.synUtil.getFileName(value.name) + "_" + synData.sessionGUID;
                                    if (value.fileGuid)
                                        fileKey += "_" + value.fileGuid;
                                    delete synData.mapFileToGUID[fileKey];
                                });
                            }
                            else {
                                for (let key in e.response) {
                                    if (e.response.hasOwnProperty(key)) {
                                        let val = e.response[key];
                                        synData.mapFileToGUID[key] = val;
                                    }
                                }
                            }
                            $this.trigger("uploadSuccess", [e]);
                            $(".k-file").css("color: orange");
                        }
                    },
                    upload(e) {
                        const synData = $this.data("synData");
                        if (e.sender.options.async)
                            e.sender.options.async.saveUrl = synData.uploadUrl + "?csrfToken=" + Utilities_1.synUtil.requestVerificationToken
                                + (synData.checkForCategory ? "&checkForCategory=" + synData.checkForCategory.toString() : "")
                                + (synData.checkForDocument ? "&checkForDocument=" + synData.checkForDocument.toString() : "");
                        let str = "";
                        $.each(e.files, function (idx, file) {
                            str += file.name;
                            if (e.files && idx < e.files.length - 1)
                                str += "|";
                        });
                        e.data = {
                            sessionGUID: synData.sessionGUID,
                            base64FileNames: Base64_1.Base64.encode(str)
                        };
                        $this.trigger("beginUpload", [e.files]);
                    }
                }).data("kendoUpload");
                $this.data("synData", mergedData);
                $this.addClass("synUpload");
                if ("phone" === Utilities_1.synUtil.clientDeviceClass)
                    $this.addClass("phone");
            }
        });
    }
    static clearList($elem, serverSideDelete) {
        const synData = $elem.data("synData");
        if (synData) {
            $elem.children(".k-widget").addClass("k-upload-empty");
            $elem.find(".k-upload-status").remove();
            $elem.find(".k-upload-files.k-reset").remove();
            let arr = [];
            let keyArr = [];
            for (let key in synData.mapFileToGUID) {
                if (synData.mapFileToGUID.hasOwnProperty(key)) {
                    keyArr.push(key);
                    if (synData.mapFileToGUID[key])
                        arr.push(synData.mapFileToGUID[key]);
                }
            }
            for (let i = 0; i < keyArr.length; i++)
                delete synData.mapFileToGUID[keyArr[i]];
            let deleteGUIDs = arr.join(";");
            if (serverSideDelete && synData.removeUrl && deleteGUIDs.length) {
                Utilities_1.synUtil.getAJAXData({
                    method: "DELETE",
                    url: synData.removeUrl,
                    requestData: { deleteGUIDs, sessionGUID: synData.sessionGUID }
                });
            }
        }
    }
    static destroy($elem) {
        return $elem.each(function () {
            const $this = $(this);
            const synData = $this.data("synData");
            let upload = synData.upload;
            if (synData && upload) {
                upload.destroy();
                $this.removeData("synData");
            }
            $this.off("beginUpload");
            $this.off("uploadCancelled");
            $this.off("uploadComplete");
            $this.off("uploadError");
            $this.off("uploadProgress");
            $this.off("fileRemoved");
            $this.off("fileSelected");
            $this.off("uploadError");
            $this.html("");
        });
    }
    static getFileGuids($elem) {
        let guids = [];
        const synData = $elem.data("synData");
        if (synData) {
            for (let key in synData.mapFileToGUID) {
                if (!synData.cancelledItems[key]) {
                    let guid = synData.mapFileToGUID[key];
                    if (guid)
                        guids.push(guid);
                }
            }
        }
        return guids;
    }
    static getFileNameFromGuid($elem, fromGuid) {
        const synData = $elem.data("synData");
        if (synData) {
            for (let key in synData.mapFileToGUID) {
                if (!synData.cancelledItems[key]) {
                    let guid = synData.mapFileToGUID[key];
                    if (guid && fromGuid === guid && (key.indexOf("_") >= 0))
                        return key.substring(0, key.lastIndexOf("_"));
                }
            }
        }
        return undefined;
    }
    static setCategory($elem, categoryId) {
        const synData = $elem.data("synData");
        if (synData) {
            synData.checkForCategory = categoryId;
            delete synData.checkForDocument;
        }
    }
    static setDocument($elem, documentId) {
        const synData = $elem.data("synData");
        if (synData) {
            synData.checkForDocument = documentId;
            delete synData.checkForCategory;
        }
    }
    static enable($elem, enable) {
        return $elem.each(function () {
            const synData = $elem.data("synData");
            let upload = synData.upload;
            if (synData && upload)
                upload.enable(enable);
        });
    }
}
exports.Upload = Upload;
// Dispatcher code
(($) => {
    $.fn.synUpload = function (method) {
        if (Upload[method])
            return Upload[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return Upload.init(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.SynUpload");
    };
})(jQuery);
